

















import {
  PropType,
  computed,
  defineComponent,
  onMounted,
  ref,
} from "@nuxtjs/composition-api";
import { SfReview } from "@storefront-ui/vue";
import HTMLContent from "~/components/HTMLContent.vue";
import { ProductReview } from "~/composables";
import ProductAddReviewForm from "~/modules/catalog/product/components/ProductAddReviewForm.vue";
import { TabsConfig } from "~/modules/catalog/product/composables/useProductTabs";
import { Product } from "~/modules/catalog/product/types";
import {
  UseReviewAddReviewParams,
  useReview,
} from "~/modules/review/composables/useReview";
import reviewGetters, {
  getReviewAuthor,
  getReviewDate,
  getReviewId,
  getReviewMessage,
  getReviewRating,
} from "~/modules/review/getters/reviewGetters";
import { usePageStore } from "~/stores/page";

export default defineComponent({
  name: "ProductInfo",
  components: {
    ProductAddReviewForm,
    HTMLContent,
    SfReview,
  },
  props: {
    product: {
      type: Object as PropType<Product | null>,
      default: null,
    },
    openTab: {
      type: Number,
      default: TabsConfig.description.ID,
    },
  },
  setup(props) {
    const { routeData } = usePageStore();
    const isReviewsLoading = ref(true);
    const accordionOpened = ref(false);
    const reviews = ref<ProductReview[]>([]);

    const fetchReviews = async () => {
      try {
        const productReviews = await searchReviews(getSearchQuery());
        const baseReviews = Array.isArray(productReviews)
          ? productReviews[0]
          : productReviews;

        reviews.value = reviewGetters.getItems(baseReviews);
      } catch (error) {
        console.error("Failed to fetch reviews:", error);
      } finally {
        isReviewsLoading.value = false;
      }
    };

    onMounted(async () => {
      await fetchReviews();
    });

    const { search: searchReviews, addReview } = useReview();

    const getSearchQuery = () => ({
      filter: {
        sku: {
          eq: routeData.sku,
        },
      },
    });

    const toggleAccordion = () => {
      accordionOpened.value = !accordionOpened.value;
    };

    const isMobile = computed(
      () => typeof window !== "undefined" && window.innerWidth <= 768
    );

    const shouldShowAddReview = computed(
      () => isMobile.value || accordionOpened.value
    );

    const productDescription = computed(
      () => props.product?.description?.html || ""
    );

    const successAddReview = async (reviewData: UseReviewAddReviewParams) => {
      await addReview(reviewData);
      document.querySelector("#tabs")?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    };

    return {
      isReviewsLoading,
      getReviewId,
      getReviewAuthor,
      getReviewDate,
      getReviewMessage,
      getReviewRating,
      productDescription,
      successAddReview,
      reviews,
      isMobile,
      toggleAccordion,
      accordionOpened,
      shouldShowAddReview,
    };
  },
});
